<div class="legend">
  <div class="legend-item" *ngFor="let legendItem of legends">
    <div [ngClass]="{'legend-box': !legendItem.line, 
                     'legend-line': legendItem.line}" class="legend-box" [ngStyle]="{'background-color': legendItem.color}">
    </div>
    <div class="legend-text" [ngClass]="{'hide': legendItem.hide}" (click)="getStatus(legendItem)">{{legendItem.text}}{{buildingPDF ? ': ' + legendItem.count : ''}}</div>
  </div>
</div>